import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CheckCircle2Icon, GiftIcon } from 'lucide-react';
import { PreviewCarousel } from './PreviewCarousel';
import { bonuses, capabilities, volumes } from '../data/offer';
import type { Volume } from '../types/content';
const accentStyles: Record<Volume['accent'], {
  border: string;
  text: string;
}> = {
  info: {
    border: 'border-info/30',
    text: 'text-info'
  },
  primary: {
    border: 'border-primary-soft/30',
    text: 'text-primary-soft'
  },
  highlight: {
    border: 'border-highlight/30',
    text: 'text-highlight'
  },
  danger: {
    border: 'border-danger-soft/30',
    text: 'text-danger-soft'
  }
};
export function ProductOffer() {
  return <>
      <section className="bg-surface px-4 py-16 sm:py-24" data-id="element-148" data-mp="ugxh5jwq0ua1">
        <div className="mx-auto max-w-5xl" data-id="element-149" data-mp="fin1hk1e57in">
          <header className="text-center" data-id="element-150" data-mp="fjx14dnw6nre">
            <h2 className="font-display text-3xl font-bold text-highlight sm:text-5xl" data-id="element-151" data-mp="khyj0v9l0h1a">
              🏆SISTEMA EQUILIBRIO EN CASA™
            </h2>
            <p className="mx-auto mt-4 max-w-4xl text-lg font-medium" data-id="element-152" data-mp="3ldi1w6r7yu73">
              Tu sistema en 4 volúmenes para identificar lo que necesitás, aplicar prácticas y crear rutinas simples para tu día a día.
            </p>
          </header>
          
          <h3 className="mt-12 text-center font-display text-2xl font-bold" data-id="element-153" data-mp="3qefkgkg55q94">
            📚 4 VOLÚMENES COMPLETOS
          </h3>
          
          <div className="mt-7 space-y-5" data-id="element-154" data-mp="32p3b9kktdi6t">
            {volumes.map((volume, index) => {
            const accent = accentStyles[volume.accent];
            return <motion.article key={volume.title} initial={{
              opacity: 0,
              y: 16
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.06
            }} className={`flex gap-5 rounded-2xl border ${accent.border} bg-canvas p-5 sm:p-7`} data-id="element-155" data-mp="3bgn5bteib3vg" data-mpi={index}>
                  <BookOpenIcon className={`mt-1 h-7 w-7 shrink-0 ${accent.text}`} aria-hidden="true" data-id="element-156" data-mp="hymmmag6kppb" />
                  <div className="flex-1" data-id="element-157" data-mp="mx6c2ktzgjmf">
                    <p className={`text-xs font-bold tracking-brand ${accent.text}`} data-id="element-158" data-mp="mvv6qgkw33t7">
                      {volume.label}
                    </p>
                    <h4 className="mt-1 font-display text-lg font-bold sm:text-xl" data-id="element-159" data-mp="wmzm3heh8qok">
                      {volume.title}
                    </h4>
                    <p className="mt-1 text-sm text-foreground-subtle sm:text-base" data-id="element-160" data-mp="3v66gl44qx520">
                      {volume.subtitle}
                    </p>
                    <ul className="mt-4 space-y-2" data-id="element-161" data-mp="8xoi7r1tyg67">
                      {volume.items.map(item => <li key={item} className="flex gap-2 text-sm leading-relaxed text-foreground-muted sm:text-base" data-id="element-162" data-mp="8zrid3wp5pon">
                          <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-primary-soft" aria-hidden="true" data-id="element-163" data-mp="1kd3oxmjucmei" />
                          {item}
                        </li>)}
                    </ul>
                    <p className="mt-5 border-t border-foreground/10 pt-4 text-sm sm:text-base" data-id="element-164" data-mp="39tpgrmjwagwu">
                      <span className="font-semibold text-foreground-subtle" data-id="element-165" data-mp="34v4hbpcgw19g">Resultado: </span>
                      <span className={`font-bold italic ${accent.text}`} data-id="element-166" data-mp="303w6qpzei9up">{volume.result}</span>
                    </p>
                  </div>
                </motion.article>;
          })}
          </div>
        </div>
      </section>
      <PreviewCarousel data-id="element-167" data-mp="2q71909aycdhh" />
      <section className="bg-canvas px-4 py-16 sm:py-24" data-id="element-168" data-mp="2q7jdft7rpy0h">
        <div className="mx-auto max-w-5xl" data-id="element-169" data-mp="2m3v538bbaye6">
          <header className="text-center" data-id="element-170" data-mp="2m338bu5zaumb">
            <GiftIcon className="mx-auto h-10 w-10 text-highlight" aria-hidden="true" data-id="element-171" data-mp="2h51ov84n4tab" />
            <h2 className="mt-3 font-display text-3xl font-bold text-highlight sm:text-5xl" data-id="element-172" data-mp="2c6707pjzsaia">
              Y ADEMÁS, TE LLEVÁS 5 BONOS
            </h2>
          </header>
          <div className="mt-10 space-y-4" data-id="element-173" data-mp="fd5ew2y4frhn">
            {bonuses.map(({
            number,
            title,
            detail,
            items,
            value
          }) => <article key={number} className="flex flex-col gap-4 rounded-2xl border border-highlight/20 bg-surface p-5 sm:flex-row sm:items-start sm:p-7" data-id="element-174" data-mp="3484yeab6x584">
                <span className="w-fit whitespace-nowrap rounded-lg bg-highlight/10 px-3 py-2 font-bold text-highlight" data-id="element-175" data-mp="2u8w8bsjg4ar1">
                  🎁 BONO {number}
                </span>
                <div className="flex-1" data-id="element-176" data-mp="2z9jxe8o46him">
                  <h3 className="font-bold" data-id="element-177" data-mp="2kikqr36ua31o">{title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-muted" data-id="element-178" data-mp="2kgzwzfscmo4v">
                    {detail}
                  </p>
                  <ul className="mt-3 space-y-1.5" data-id="element-179" data-mp="2bio7xi74ryej">
                    {items.map(item => <li key={item} className="flex gap-2 text-sm leading-relaxed text-foreground-muted" data-id="element-180" data-mp="2gh8ysr0ht5qb">
                        <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-highlight" aria-hidden="true" data-id="element-181" data-mp="21jytjzeg0w31" />
                        {item}
                      </li>)}
                  </ul>
                </div>
                <div className="flex shrink-0 items-center gap-3" data-id="element-182" data-mp="1mwqaydit1oh1">
                  <span className="text-xs font-semibold text-foreground-faint" data-id="element-183" data-mp="1mz30pcut134n">VALOR:</span>
                  <span className="text-sm text-foreground-faint line-through" data-id="element-184" data-mp="1ixrap680qfvx">
                    {value}
                  </span>
                  <span className="rounded-full bg-primary-soft px-3 py-1 text-sm font-bold text-canvas" data-id="element-185" data-mp="1rvtgdz2p5wpj">
                    GRATIS
                  </span>
                </div>
              </article>)}
          </div>
          <div className="mt-8 rounded-2xl border border-highlight/30 bg-highlight/10 p-6 text-center" data-id="element-186" data-mp="21vbuhyvxeo9o">
            <p className="text-xs font-bold tracking-brand text-highlight" data-id="element-187" data-mp="2fkvw31drtfhe">
              VALOR TOTAL BONOS
            </p>
            <p className="mt-1 text-2xl font-bold text-foreground-subtle line-through" data-id="element-188" data-mp="2anm9dthrnhx9">
              $52.000
            </p>
            <p className="mt-2 font-display text-xl font-bold text-highlight" data-id="element-189" data-mp="2phqqb830gtpv">
              GRATIS con tu Sistema Equilibrio en Casa™
            </p>
          </div>
        </div>
      </section>
    </>;
}